<template>
  <div class="footer-bar d-flex flex-column justify-content-between p-4 text-secondary">
    <h5 v-if="$store.state.respecifyId && !showDigikey" class="text-info">Du befindest dich im Nachkonfigurationsmodus (alte Werte in Tabelle)</h5>
    <table 
      v-if="$store.state.respecifyId && !showDigikey"
      class="table table-striped table-sm text-secondary"
      >
      <thead>
        <tr>
          <th 
            v-for="header in ['Eigenschaft', 'Wert']"
            :key="header">{{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(option, index) in $store.state.respecifyData"
          :key="index">
          <td>{{ option.key }}</td>
          <td>{{ option.value }}</td>
        </tr>
      </tbody>
    </table>

    <div class="d-flex justify-content-between text-secondary">
      <div class="d-flex flex-column w-75">
        <fetch-price  :cable-length="cableLength" v-if="($store.state.showPrice && $store.state.loggedIn) && activePage !== 'done' || window.location.hostname === 'emcom-go-dw2'">
          <div slot-scope="{ price, loading, cablePricePerMeter }">
            <button v-if="loading" class="price-tag pointer-events-none btn btn-sm px-4 py-2 rounded-pill bg-saka-green text-light">{{ $t('calculate-price') }}</button>
            <button v-else class="price-tag pointer-events-none btn btn-sm px-4 py-2 rounded-pill bg-saka-green text-light">
              {{ new Intl.NumberFormat($i18n.locale === 'de' ? 'de-DE': 'en-US', {style: 'currency', currency: 'EUR'}).format(price) }}</button>
            <span 
              v-if="$store.state.features.displayPricePerMeter && cablePricePerMeter"
              class="ml-3 py-2 text-saka-green">ca. {{ new Intl.NumberFormat($i18n.locale === 'de' ? 'de-DE' : 'en-US', { style: 'currency', currency: 'EUR'}).format(cablePricePerMeter) }}{{ $t('perMeter') }}</span>
          </div>
        </fetch-price>
        <span class="mt-3" v-if="displayHints({ configuratorType: $route.name, page:  activePage}).length > 0">{{ $t('information') }}</span>
        <information-list :hints="additionalHints.concat(displayHints({ configuratorType: $route.name, page:  activePage}))" />
        <portal-target name="summary"></portal-target>
      </div>
      <portal-target name="configuration-navigation" class="w-25"></portal-target>
    </div>

    <slot />
    
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import InformationList from './InformationList'
import FetchPrice from './FetchPrice'

export default {
  name: 'FooterBar',
  data: () => ({
    env: process.env.NODE_ENV,
    window,
    showDigikey: null
  }),
  props: {
    activePage: {
      type: String,
      default: ''
    },
    additionalHints: {
      type: Array,
      default: ()=> []
    }
  },
  computed: {
    ...mapGetters([
      'remainingCables',
      'remainingPlugsA',
      'remainingPlugsB',
      'filteredBendProtectionsA',
      'filteredBendProtectionsB',
      'linearizedPartsList',
      'displayHints'
    ]),
    ...mapState([
      'cableLength'
    ])
  },
  components: {
    InformationList,
    FetchPrice
  },
  mounted(){
    this.showDigikey = localStorage.getItem('userSource');
  }

}
</script>
<style scoped>
.price-tag {
  width: 140px;
}
</style>
